import React from 'react';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import environmentStore from '@di-shared/features/environment/environmentStore';
import VehicleInspectionReservationDetail from '@di-shared/features/public-service/vehicle-inspection/reservation/VehicleInspectionReservationDetail';

export interface VehicleInspectionReservationPageProps {
  vin: string;
  reservationNumber: string;
}

function VehicleInspectionReservationPage({vin, reservationNumber}: VehicleInspectionReservationPageProps): JSX.Element {
  const {t} = useInferableTranslation();
  const puid = environmentStore.getState().puid;

  return (
    <div className="wrap">
      <Header left={<HeaderBackButton />}>
        <h1 className="title_xsmall_b nav_center_title">{t('T30535')}</h1>
      </Header>
      <VehicleInspectionReservationDetail
        puid={puid}
        vin={vin}
        reservationNumber={reservationNumber}
      />
    </div>
  );
}

export default VehicleInspectionReservationPage;
